import React, { useState } from 'react';
import Label from './Label';

// This is a functional component. It's a JavaScript function that takes props as an argument.
const Checkbox = ({
    id,
    inputClasses = 'form-checkbox border border-gray-300 h-5 w-5 text-primary-brand rounded rounded-md focus:border-ring-primary-500', 
    labelClasses = 'text-sm font-medium ml-2', // Default classes for the label

    checked: initialChecked = false, // Rename 'checked' to 'initialChecked' to avoid naming conflict with state
    onChange, // This is the onChange from the parent component
    label,
    ...rest // Capture any other props like className, name, etc.
}) => {
    // Use useState to manage the internal 'checked' state of the checkbox
    const [isChecked, setIsChecked] = useState(initialChecked);

    // This function handles the change event of the input
    const handleInputChange = (e) => {
        setIsChecked(e.target.checked); // Update the internal state
        if (onChange) {
            // If the parent component provided an onChange handler, call it
            onChange(e);
        }
    };

    return (
        <div>
            <input
                id={id} // Use the id passed in props
                className={inputClasses}
                type="checkbox"
                checked={isChecked} // The checkbox's checked state is controlled by our internal 'isChecked' state
                onChange={handleInputChange} // Our local handler
                {...rest} // Spread any additional props (like 'className', 'name', 'value' etc.)
            />
            <Label className={labelClasses} htmlFor={id} label="Remember me"/>
            
        </div>
    );
};

export default Checkbox;